import React from 'react';
import type { PickerProps } from './Picker.types';
import { PickerContainer, PickerControl } from './subcomponents';
import { usePickerState } from './Picker.hooks';
import { useUniqueNativeID } from '../../../hooks';

export const Picker = (props: PickerProps) => {
  const {
    options,
    value,
    onSubmit,
    label,
    modalTitle,
    submitBtnLabel,
    variation,
  } = props;
  const labelNativeID = useUniqueNativeID('picker-label');

  const {
    selectedOptionValue,
    selectedOptionLabel,
    setSelectedOptionValue,
    handleSubmit,
    resetSelectedOptionValue,
  } = usePickerState({ value, options, onSubmit });

  // ────────────────────────────────────────────────────────────────────

  return (
    <PickerContainer
      label={label}
      labelNativeID={labelNativeID}
      modalTitle={modalTitle}
      submitBtnLabel={submitBtnLabel}
      selectedOptionLabel={selectedOptionLabel}
      variation={variation}
      onSubmitBtnPress={handleSubmit}
      onDismiss={resetSelectedOptionValue}
    >
      <PickerControl
        value={selectedOptionValue}
        options={options}
        onChange={setSelectedOptionValue}
        accessibilityDescribedBy={labelNativeID}
      />
    </PickerContainer>
  );
};
